<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Rate</h1>

                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>

            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <div class="" v-if="userRole === 'locum'">

                    <div class="profile_rate" v-if="userRole === 'locum'">
                       
                        <div class="form_text">
                            <div class="title">Minimum rate per hour</div>
                            <div class="text_note" v-if="isAustralia">(excluding super)</div>
                        </div>

                        <el-form-item prop="minRate">
                            <div class="el-input el-input--suffix">
                                <input type="tel" class="input_currency el-input__inner"
                                    :ref="(el) => (formsData.userForm.minRate.ref = el)"
                                    :value="formsData.userForm.minRate.value" :placeholder="'0.00'"
                                    v-imask="formsData.userForm.minRate.mask" @accept="($event) => {
                                        onFormMaskAccept($event, 'userForm', 'minRate');
                                        checkFormValidation('userForm', true);
                                    }
                                        " @blur="checkFormValidation('userForm', true)" />
                                <span class="el-input__suffix">AUD</span>
                            </div>
                        </el-form-item>

                    </div>

                    <div class="profile_rate" v-if="userRole === 'locum'">

                        <div class="form_text">
                            <div class="title">Minimum weekend rate per hour</div>
                            <div class="text_note" v-if="isAustralia">(excluding super)</div>
                            <div class="text_note"></div>
                        </div>
                        <el-form-item prop="weekendRate">
                            <div class="el-input el-input--suffix">
                                <input type="tel" class="input_currency el-input__inner"
                                    :value="formsData.userForm.weekendRate.value" :placeholder="'0.00'"
                                    v-imask="formsData.userForm.minRate.mask"
                                    :disabled="formsData.userForm.weekendRate.disabled" @accept="($event) => {
                                        onFormMaskAccept($event, 'userForm', 'weekendRate');
                                        checkFormValidation('userForm', true);
                                    }
                                        " @blur="checkFormValidation('userForm', true)" />
                                <span class="el-input__suffix">AUD</span>
                            </div>
                        </el-form-item>
                    </div>

                    <el-form-item v-if="userRole === 'locum'">
                        <el-checkbox v-model="formsData.userForm.weekendRate.disabled"
                            @change="onNameCheckboxChange" :disabled="formsData.userForm.minRate.value === null">Same as
                            Weekday rate
                        </el-checkbox>
                    </el-form-item>
                </div>


                <el-form-item class="button_submit mb0">
                    <el-button class="submit" type="blue" @click="goNext('userForm')"
                        :disabled="formsData.userForm.disabled">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
            </div>
        </div>
    </div>
</template>


<script>
import {
    onMounted,
    inject,
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import formMasks from '@/hooks/form/mask/mask'
import { ElMessageBox } from "@/components/Vendor/Element";
import IMaskDirective from '@/directives/vue-imask/directive';
import IMask from 'imask/esm/imask';
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
    },
    directives: {
        imask: IMaskDirective
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const minRate = userData.minRate;
        const weekendRate = userData.weekendRate;



        const formsDataArray = {
            userForm: {
                minRate: {
                    ref: {},
                    value: minRate
                        ? IMask.createMask(formMasks.rate).resolve("" + minRate)
                        : null,
                    resetValue: true,
                    mask: formMasks.rate,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "minRate",
                                    callback,
                                    setFormValidation
                                );
                            },
                            trigger: "change",
                        },
                    ],
                },
                weekendRate: {
                    ref: {},
                    valueTemp: "",
                    value: weekendRate
                        ? IMask.createMask(formMasks.rate).resolve("" + weekendRate)
                        : null,
                    resetValue: true,
                    mask: formMasks.rate,
                    disabled: (minRate === weekendRate && minRate !== null)  ? true : false,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "weekendRate",
                                    callback,
                                    setFormValidation
                                );
                            },
                            trigger: "change",
                        },
                    ],
                },
            }
        };
       
        const goBack = async() => {
            const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: back,
            });  
        };


        const goNext = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            const data = getFormValues(formName);

                            await $store.dispatch('SAVE_USER_DATA', data);
                            $router.push({
                                name: 'auth_travel_preferences',
                            })
                        } catch (error) {
                            console.log('error submit!!');
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log('error submit!!');
                    return false;
                }
            });
        };

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'auth_travel_preferences',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();

        }

        const onNameCheckboxChange = () => {
            if (formsData.userForm.weekendRate.disabled) {
                formsData.userForm.weekendRate.valueTemp =
                    formsData.userForm.weekendRate.value;
                formsData.userForm.weekendRate.value = formsData.userForm.minRate.value;
                // formsData.userForm.weekendRate.value = userData.minRate;
                formsData.userForm.weekendRate.disabled = true;
            } else {
                formsData.userForm.weekendRate.value =
                    formsData.userForm.weekendRate.valueTemp;

                formsData.userForm.weekendRate.disabled = false;
            }
            // checkFormValidation("userForm", true, "weekendRate");
            checkFormValidation("userForm", true);
        };

   

        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();
            formsRefs.userForm.value.$el[0].focus();
            checkFormValidation('userForm', false);
        });

        const {
            onFormMaskAccept,
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            formsData,
            onFormMaskAccept,
            checkFormValidation,
            goBack,
            goNext,
            skip,
            userRole,
            onNameCheckboxChange,
        }
    },
}
</script>